const {REACT_APP_CLOUDFRONT_URL} = process.env;

export const joinPathImage = path => {
  return `${REACT_APP_CLOUDFRONT_URL}/${path}`;
};
